// extracted by mini-css-extract-plugin
export default {"withTabbarBottom":"style_withTabbarBottom__JC366","withoutTabbarBottom":"style_withoutTabbarBottom__ZV2Re","newAppVersionBackgroundImage":"style_newAppVersionBackgroundImage__lY2Ze"};